export default __webpack_public_path__ + "static/404-344f3a15fee56a7dc523fe8148d6ab5f.png";